/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { getUrlSync, IComponent, IComponentProps } from '@msdyn365-commerce/core';
import { ICartState } from '@msdyn365-commerce/global-state';
import { format, getPayloadObject, ITelemetryContent, onTelemetryClick } from '@msdyn365-commerce-modules/utilities';
import { observer } from 'mobx-react';
import * as React from 'react';

export interface ICartIconData {
    cart?: ICartState;
}

export interface ICartIconComponentProps extends IComponentProps<ICartIconData> {
    className?: string;
    cartLabel: string;
    cartQtyLabel: string;
    telemetryContent?: ITelemetryContent;
}

export interface ICartIconComponent extends IComponent<ICartIconComponentProps> {}

/**
 *
 * CartIcon component.
 * @extends {React.PureComponent<ICartIconProps>}
 */

@observer
export class CartIcon extends React.PureComponent<ICartIconComponentProps> {
    constructor(props: ICartIconComponentProps) {
        super(props);
    }

    public render(): JSX.Element {
        const {
            cartLabel,
            cartQtyLabel,
            data: { cart }
        } = this.props;
        const cartLink = getUrlSync('cart', this.props.context.actionContext);

        // If there are invoice lines, don't update mini cart item quantity
        const cartItem = cart ? cart.totalItemsInCart : 0;
        const qtyLabel = format(cartQtyLabel, cartItem);
        const itemCount = qtyLabel.replace('(', '');
        const itemCountNew = itemCount.replace(')', '');
        const label = format(cartLabel, cartItem);

        // Construct telemetry attribute to render
        const payLoad = getPayloadObject('click', this.props.telemetryContent!, 'cart-icon', '');
        //const attributes = getTelemetryAttributes(this.props.telemetryContent!, payLoad);
        const style: React.CSSProperties = {
            visibility: cart ? 'visible' : 'hidden'
        };
        return (
            <>
                {Number(itemCountNew) && Number(itemCountNew) > 0 ? (
                    <a
                        className='msc-cart-icon msc-btn active-cart-count'
                        href={cartLink}
                        onClick={onTelemetryClick(this.props.telemetryContent!, payLoad, '')}
                    >
                        <div className='localy-cart-icon'></div>
                        <div className='cart-quantity' aria-hidden style={style}>
                            {itemCountNew} &nbsp;Items
                        </div>
                    </a>
                ) : (
                    <>
                        <a
                            className='msc-cart-icon msc-btn active-cart-count'
                            href={cartLink}
                            aria-label={label}
                            onClick={onTelemetryClick(this.props.telemetryContent!, payLoad, '')}
                        >
                            Cart &nbsp;
                            <div className='localy-cart-icon'></div>
                        </a>
                    </>
                )}
            </>
        );
    }
}
